import axios from "api/deepgramAxios";

// App Backend
export const getTranscribedText = async (formData) => {
  const response = await axios.post("/api/deepgram/upload/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// App Backend
export const getRegeneratedNotes = async (payload) => {
  const response = await axios.post("/api/deepgram/regenerate-notes", payload);
  return response.data;
};

// App Backend
export const getNotesWithMoreTemplates = async (payload) => {
  const response = await axios.post(
    "/api/deepgram/notes-with-more-templates",
    payload
  );
  return response.data;
};

// App Backend
export const getPatientNameFromTranscibedText = async (payload) => {
  const response = await axios.post(
    '/api/deepgram/get-patient-name',
    payload
  )
  return response.data.patientName;
}

// App Backend
export const fillDocuments = async (payload) => {
  const response = await axios.post(
    '/api/deepgram/fill-documents',
    payload
  )
  return response.data;
}

export const getRecommendation = async (payload) => {
  const response = await axios.post(
    '/api/deepgram/recommendation',
    payload
  );
  return response.data;
}

export const transcribeAudioTest = async (audioBlob) => {
  const formData = new FormData();
  formData.append("audio", audioBlob, "mic-test.webm");
  formData.append("selectedTemplateIds", []);
  const response = await axios.post("/api/deepgram/upload/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.transcription;
};